class DecisionModalSettings {
    constructor(options, selectType, modalSubheading) {
        this.options = options;
        this.type = selectType;
        this.subHeading = modalSubheading;
    }
}

export default DecisionModalSettings;